var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box" }, [
    _vm.loaded
      ? _c(
          "div",
          { staticClass: "wrap-form" },
          [
            _c(
              "a-form",
              { staticClass: "form", attrs: { form: _vm.form } },
              [
                _c(
                  "div",
                  { staticClass: "step-hint-bar" },
                  [
                    _c("div", { staticClass: "step-hint-left" }, [
                      _c("span", { staticClass: "hand-icon" }, [_vm._v("👋")]),
                      _c("div", { staticClass: "step-hint-text" }, [
                        _c("div", { staticClass: "step-hint-title" }, [
                          _vm._v(" " + _vm._s(_vm.$t("StepHintTitle")) + " "),
                        ]),
                        _c("div", { staticClass: "step-hint-desc" }, [
                          _vm._v(" " + _vm._s(_vm.$t("StepHintDesc")) + " "),
                        ]),
                      ]),
                    ]),
                    _c(
                      "a-button",
                      {
                        staticClass: "pro-hint-btn",
                        class: { "minimized-btn": !_vm.showTipsInfo },
                        attrs: { shape: "round", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("toggleIntro", !_vm.showTipsInfo)
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.showTipsInfo
                                ? _vm.$t("ProHintBtnShow")
                                : _vm.$t("ProHintBtnHide")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c("div", { attrs: { id: "campaign-create-name" } }, [
                  _c("div", { class: [_vm.lang] }, [
                    _c(
                      "div",
                      {
                        staticClass: "tit",
                        class: [_vm.lang],
                        staticStyle: {
                          width: "500px",
                          display: "inline-block",
                        },
                      },
                      [
                        _c("svg-icon", {
                          staticClass: "tit-icon",
                          attrs: { iconClass: "search" },
                        }),
                        _c("span", [_vm._v(_vm._s(_vm.$t("capaginName")))]),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { class: [_vm.lang] },
                    [
                      _c(
                        "a-form-item",
                        { class: [_vm.lang] },
                        [
                          _c("a-input", {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "campaign_name",
                                  {
                                    initialValue: _vm.campName,
                                    rules: [
                                      {
                                        trim: true,
                                        required: true,
                                        validator: async function (
                                          rule,
                                          value,
                                          callback
                                        ) {
                                          if (!value || !value.trim("")) {
                                            callback(
                                              _vm.$t(
                                                "Pleaseenterthecampaignname"
                                              )
                                            )
                                            return
                                          }
                                          // 添加逻辑校验是否存在调接口
                                          let res =
                                            await _vm.isCampaignNameLegal(value)
                                          if (!res.reslut) {
                                            callback(res.msg)
                                            return
                                          }
                                          callback()
                                        },
                                        trigger: "blur",
                                      },
                                    ],
                                    trigger: "blur",
                                  },
                                ],
                                expression:
                                  "[\n              'campaign_name',\n              {\n                initialValue: campName,\n                rules: [\n                  {\n                    trim: true,\n                    required: true,\n                    validator: async function (rule, value, callback) {\n                      if (!value || !value.trim('')) {\n                        callback($t('Pleaseenterthecampaignname'));\n                        return;\n                      }\n                      // 添加逻辑校验是否存在调接口\n                      let res = await isCampaignNameLegal(value);\n                      if (!res.reslut) {\n                        callback(res.msg);\n                        return;\n                      }\n                      callback();\n                    },\n                    trigger: 'blur',\n                  },\n                ],\n                trigger: 'blur',\n              },\n            ]",
                              },
                            ],
                            ref: "campaign_name",
                            attrs: {
                              size: "large",
                              maxLength: 30,
                              disabled: _vm.inputDisabled,
                              placeholder: _vm.$t("Pleaseenterthecampaignname"),
                            },
                          }),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showTipsInfo,
                                  expression: "showTipsInfo",
                                },
                              ],
                              staticClass: "input-tip",
                            },
                            [
                              _c("span", { staticClass: "input-tip-icon" }, [
                                _vm._v("💡"),
                              ]),
                              _c("span", {
                                staticClass: "input-tip-text",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("CampaignNameTipText")
                                  ),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { attrs: { id: "campaign-create-linkin" } }, [
                  _c("div", { class: [_vm.lang] }, [
                    _c(
                      "div",
                      {
                        staticClass: "tit",
                        class: [_vm.lang],
                        staticStyle: {
                          width: "500px",
                          display: "inline-block",
                        },
                      },
                      [
                        _c("svg-icon", {
                          staticClass: "tit-icon",
                          attrs: { iconClass: "bind" },
                        }),
                        _c("span", { class: [_vm.lang] }, [
                          _vm._v(_vm._s(_vm.$t("bindLinkAcc"))),
                        ]),
                        _c(
                          "a-popover",
                          {
                            staticStyle: { "z-index": "98" },
                            attrs: {
                              placement:
                                _vm.lang == "AR" ? "bottomRight" : "bottomLeft",
                              trigger: "click",
                            },
                            model: {
                              value: _vm.visiable,
                              callback: function ($$v) {
                                _vm.visiable = $$v
                              },
                              expression: "visiable",
                            },
                          },
                          [
                            _c("template", { slot: "content" }, [
                              _c("div", { staticClass: "popbox" }, [
                                _c(
                                  "p",
                                  {
                                    staticClass: "main-tit",
                                    class: [_vm.lang],
                                    style: {
                                      "text-align":
                                        _vm.lang == "AR" ? "right" : "left",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("bindLinkAccTipTitle1")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "ptit",
                                    class: [_vm.lang],
                                    style: {
                                      "text-align":
                                        _vm.lang == "AR" ? "right" : "left",
                                    },
                                  },
                                  [
                                    _c("span", { class: [_vm.lang] }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("bindLinkAccTipcon1"))
                                      ),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "p",
                                  {
                                    staticClass: "main-tit main-tit2",
                                    class: [_vm.lang],
                                    style: {
                                      "text-align":
                                        _vm.lang == "AR" ? "right" : "left",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("bindLinkAccTipTitle2")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "ptit",
                                    class: [_vm.lang],
                                    style: {
                                      "text-align":
                                        _vm.lang == "AR" ? "right" : "left",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "txt-red",
                                        class: [_vm.lang],
                                        style: {
                                          "text-align":
                                            _vm.lang == "AR" ? "right" : "left",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("bindLinkAccTipcon2")
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "txt-red",
                                        class: [_vm.lang],
                                        style: {
                                          "text-align":
                                            _vm.lang == "AR" ? "right" : "left",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("bindLinkAccTipcon3")
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-box",
                                    style: {
                                      "text-align":
                                        _vm.lang == "AR" ? "right" : "left",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "btn-txt",
                                        class: [_vm.lang],
                                        on: { click: _vm.goLink },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("bindLinkAccTipBtn"))
                                        ),
                                      ]
                                    ),
                                    _c("span", { class: [_vm.lang] }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("bindLinkAccTipBtnTxt"))
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                            _c("a-icon", {
                              staticStyle: {
                                "font-size": "14px",
                                color: "#0e756a",
                                cursor: "pointer",
                                "margin-left": "6px",
                              },
                              attrs: { type: "question-circle" },
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "safe-card" }, [
                    _c(
                      "div",
                      {
                        staticClass: "safe-card-header",
                        on: {
                          click: function ($event) {
                            _vm.safeCardExpanded = !_vm.safeCardExpanded
                          },
                        },
                      },
                      [
                        _c("span", [
                          _c("span", { staticClass: "shield-icon" }, [
                            _vm._v("️"),
                          ]),
                          _vm._v(" " + _vm._s(_vm.$t("SafeCardHeader"))),
                        ]),
                        _c("a-icon", {
                          attrs: { type: _vm.safeCardExpanded ? "up" : "down" },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.safeCardExpanded,
                            expression: "safeCardExpanded",
                          },
                        ],
                        staticClass: "safe-card-body",
                      },
                      [
                        _c("div", { staticClass: "safe-intro" }, [
                          _vm._v(" " + _vm._s(_vm.$t("SafeCardIntro")) + " "),
                        ]),
                        _c("div", { staticClass: "safe-grid" }, [
                          _c("div", { staticClass: "safe-item" }, [
                            _c("span", { staticClass: "safe-item-icon" }, [
                              _vm._v("🌐"),
                            ]),
                            _c("div", { staticClass: "safe-item-text" }, [
                              _c("div", { staticClass: "safe-item-title" }, [
                                _vm._v(_vm._s(_vm.$t("SafeItemProxyTitle"))),
                              ]),
                              _c("div", { staticClass: "safe-item-desc" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("SafeItemProxyDesc")) +
                                    " "
                                ),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "safe-item" }, [
                            _c("span", { staticClass: "safe-item-icon" }, [
                              _vm._v("🐢"),
                            ]),
                            _c("div", { staticClass: "safe-item-text" }, [
                              _c("div", { staticClass: "safe-item-title" }, [
                                _vm._v(_vm._s(_vm.$t("SafeItemRateTitle"))),
                              ]),
                              _c("div", { staticClass: "safe-item-desc" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("SafeItemRateDesc")) + " "
                                ),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "safe-item" }, [
                            _c("span", { staticClass: "safe-item-icon" }, [
                              _vm._v("🔒"),
                            ]),
                            _c("div", { staticClass: "safe-item-text" }, [
                              _c("div", { staticClass: "safe-item-title" }, [
                                _vm._v(_vm._s(_vm.$t("SafeItemEncryptTitle"))),
                              ]),
                              _c("div", { staticClass: "safe-item-desc" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("SafeItemEncryptDesc")) +
                                    " "
                                ),
                              ]),
                            ]),
                          ]),
                          _c("div", { staticClass: "safe-item" }, [
                            _c("span", { staticClass: "safe-item-icon" }, [
                              _vm._v("🔓"),
                            ]),
                            _c("div", { staticClass: "safe-item-text" }, [
                              _c("div", { staticClass: "safe-item-title" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("SafeItemDisconnectTitle"))
                                ),
                              ]),
                              _c("div", { staticClass: "safe-item-desc" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("SafeItemDisconnectDesc")) +
                                    " "
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                        _c(
                          "a",
                          {
                            staticClass: "learn-more",
                            attrs: {
                              target: "_blank",
                              href: "https://leadgeneration.tawk.help/article/linkedin-usage-restrictions-and-settings",
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("LearnMoreLink")))]
                        ),
                      ]
                    ),
                  ]),
                  (_vm.detailObj.linkedin_id ||
                    (this.firstReg && _vm.new_linkedin_id)) &&
                  _vm.$route.query.edit != 3
                    ? _c("div", { staticClass: "showInfo" }, [
                        _c("ul", [
                          _c("li", [
                            _c(
                              "div",
                              { staticClass: "lc", class: [_vm.lang] },
                              [
                                _c("svg-icon", {
                                  staticClass: "l-icon",
                                  attrs: { iconClass: "email" },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "t1", class: [_vm.lang] },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("Account")) + "： "
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "t2", class: [_vm.lang] },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.detailObj.linkedin_email
                                          ? _vm.detailObj.linkedin_email
                                          : _vm.formData.linkedin_email
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm.detailObj.time_zone ||
                          _vm.formData.timezone_config_id
                            ? _c("li", [
                                _c(
                                  "div",
                                  { staticClass: "lc", class: [_vm.lang] },
                                  [
                                    _c("svg-icon", {
                                      staticClass: "l-icon",
                                      attrs: { iconClass: "timezone" },
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "t1", class: [_vm.lang] },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("TimeZone")) +
                                            "： "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "t2", class: [_vm.lang] },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.detailObj.time_zone
                                              ? _vm.getTimez(
                                                  _vm.detailObj.time_zone
                                                )
                                              : _vm.getTimez(
                                                  _vm.formData
                                                    .timezone_config_id
                                                )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "rc" },
                                  [
                                    _c("svg-icon", {
                                      staticClass: "r-icon",
                                      attrs: { iconClass: "right" },
                                    }),
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("Connected")) + " "
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _vm.detailObj.proxy_manually ||
                          _vm.formData.country_config_id
                            ? _c("li", [
                                _c(
                                  "div",
                                  { staticClass: "lc", class: [_vm.lang] },
                                  [
                                    _c("svg-icon", {
                                      staticClass: "l-icon",
                                      attrs: { iconClass: "global" },
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "t1", class: [_vm.lang] },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("Proxy")) + "： "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "t2", class: [_vm.lang] },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.detailObj.proxy_settings
                                              ? _vm.getcountry(
                                                  _vm.detailObj.proxy_settings
                                                )
                                              : _vm.getcountry(
                                                  _vm.formData.country_config_id
                                                )
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _c("li", { staticStyle: { "margin-bottom": "0" } }, [
                            _c(
                              "div",
                              { staticClass: "lc", class: [_vm.lang] },
                              [
                                _c("a-icon", {
                                  staticClass: "l-icon",
                                  staticStyle: { color: "#0e756a" },
                                  attrs: { type: "schedule" },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "t1", class: [_vm.lang] },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("LinkedinAvailabilitySchedule")
                                        ) +
                                        "： "
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  { staticClass: "t2", class: [_vm.lang] },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.detailObj.working_time == 1
                                          ? _vm.$t("BusinessHoursMS")
                                          : _vm.detailObj.working_time == 2
                                          ? _vm.$t("BusinessHoursMF")
                                          : _vm.$t("AlwaysOn")
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                  (!_vm.firstReg && !_vm.$route.query.edit) ||
                  _vm.$route.query.edit == 3
                    ? _c(
                        "div",
                        { staticClass: "wrap-link-list" },
                        [
                          _c(
                            "a-form-item",
                            { class: [_vm.lang] },
                            [
                              _c(
                                "a-radio-group",
                                {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: [
                                        "link_id",
                                        {
                                          initialValue: _vm.default_link_id,
                                          rules: [
                                            {
                                              required: true,
                                              message:
                                                _vm.$t("inputLinkAccount"),
                                            },
                                          ],
                                        },
                                      ],
                                      expression:
                                        "[\n              'link_id',\n              {\n                initialValue: default_link_id,\n                rules: [\n                  {\n                    required: true,\n                    message: $t('inputLinkAccount'),\n                  },\n                ],\n              },\n            ]",
                                    },
                                  ],
                                  on: { change: _vm.selectedRadio },
                                },
                                [
                                  _c(
                                    "ul",
                                    _vm._l(
                                      _vm.linkList,
                                      function (item, index) {
                                        return _c("li", { key: index }, [
                                          _c(
                                            "label",
                                            { staticStyle: { width: "100%" } },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "text" },
                                                [
                                                  _c("svg-icon", {
                                                    staticClass: "icon",
                                                    attrs: {
                                                      iconClass: "email",
                                                    },
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item.linkedin_email
                                                      ) +
                                                      " "
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c("a-radio", {
                                                attrs: {
                                                  value: item.linkedin_id,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm.$route.query.linkedin_id == "new" &&
                _vm.processing &&
                _vm.firstReg
                  ? [
                      _c("div", { staticClass: "processing" }, [
                        _c(
                          "div",
                          { staticClass: "cstep" },
                          [
                            _vm.processStep.step1 == 0
                              ? _c("div", { staticClass: "number" }, [
                                  _vm._v("1"),
                                ])
                              : _vm._e(),
                            _vm.processStep.step1 == 1
                              ? _c("svg-icon", {
                                  staticClass: "cicon",
                                  attrs: { iconClass: "wrong" },
                                })
                              : _vm._e(),
                            _vm.processStep.step1 == 2
                              ? _c("svg-icon", {
                                  staticClass: "cicon rotating",
                                  attrs: { iconClass: "load" },
                                })
                              : _vm._e(),
                            _vm.processStep.step1 == 3
                              ? _c("svg-icon", {
                                  staticClass: "cicon",
                                  attrs: { iconClass: "right" },
                                })
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass: "text",
                                class: {
                                  wrong: _vm.processStep.step1 == 1,
                                  right:
                                    _vm.processStep.step1 == 2 ||
                                    _vm.processStep.step1 == 3,
                                },
                              },
                              [
                                _c("span", { class: [_vm.lang] }, [
                                  _vm._v(_vm._s(_vm.$t("ObtainProxyIP"))),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "splitbox getProxy" }, [
                          _vm.processStep.step1 == 1
                            ? _c(
                                "div",
                                { staticClass: "asset" },
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      class: [_vm.lang],
                                      staticStyle: {
                                        width: "316px",
                                        "margin-bottom": "0",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "wrap-select" },
                                        [
                                          _c("svg-icon", {
                                            staticClass: "prefix",
                                            attrs: { iconClass: "global" },
                                          }),
                                          _c(
                                            "a-select",
                                            {
                                              directives: [
                                                {
                                                  name: "decorator",
                                                  rawName: "v-decorator",
                                                  value: [
                                                    "country_config_id",
                                                    {
                                                      rules: [
                                                        {
                                                          required: true,
                                                          message:
                                                            _vm.$t(
                                                              "selectRegion"
                                                            ),
                                                        },
                                                      ],
                                                    },
                                                  ],
                                                  expression:
                                                    "[\n                      'country_config_id',\n                      {\n                        rules: [\n                          {\n                            required: true,\n                            message: $t('selectRegion'),\n                          },\n                        ],\n                      },\n                    ]",
                                                },
                                              ],
                                              staticClass:
                                                "process-input process-select",
                                              attrs: {
                                                size: "large",
                                                "filter-option":
                                                  _vm.filterOption,
                                                showSearch: "",
                                                placeholder:
                                                  _vm.$t("SelectProxyRegion"),
                                              },
                                            },
                                            _vm._l(
                                              _vm.locationList,
                                              function (item, index) {
                                                return _c(
                                                  "a-select-option",
                                                  {
                                                    key: index,
                                                    class: [_vm.lang],
                                                    attrs: { value: item.id },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(item.show_name) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                        _c(
                          "div",
                          { staticClass: "cstep" },
                          [
                            _vm.processStep.step2 == 0
                              ? _c("div", { staticClass: "number" }, [
                                  _vm._v("2"),
                                ])
                              : _vm._e(),
                            _vm.processStep.step2 == 1
                              ? _c("svg-icon", {
                                  staticClass: "cicon",
                                  attrs: { iconClass: "wrong" },
                                })
                              : _vm._e(),
                            _vm.processStep.step2 == 2
                              ? _c("svg-icon", {
                                  staticClass: "cicon rotating",
                                  attrs: { iconClass: "load" },
                                })
                              : _vm._e(),
                            _vm.processStep.step2 == 3
                              ? _c("svg-icon", {
                                  staticClass: "cicon",
                                  attrs: { iconClass: "right" },
                                })
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass: "text",
                                class: {
                                  wrong: _vm.processStep.step2 == 1,
                                  right:
                                    _vm.processStep.step2 == 2 ||
                                    _vm.processStep.step2 == 3,
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.$t("VerifyLink")) + " ")]
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "splitbox getProxy" }, [
                          _vm.processStep.step2 == 1
                            ? _c(
                                "div",
                                { staticClass: "asset" },
                                [
                                  _c(
                                    "a-form-item",
                                    {
                                      class: [_vm.lang],
                                      staticStyle: { "margin-bottom": "20px" },
                                    },
                                    [
                                      _c(
                                        "a-input",
                                        {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value: [
                                                "linkedin_email",
                                                {
                                                  trim: true,
                                                  rules: [
                                                    {
                                                      required: true,
                                                      validator: function (
                                                        rule,
                                                        value,
                                                        callback
                                                      ) {
                                                        let reg =
                                                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                                        if (
                                                          !value ||
                                                          !value.trim("") ||
                                                          !reg.test(value)
                                                        ) {
                                                          callback(
                                                            _vm.$t(
                                                              "rightAccount"
                                                            )
                                                          )
                                                          return
                                                        }
                                                        callback()
                                                      },
                                                    },
                                                  ],
                                                },
                                              ],
                                              expression:
                                                "[\n                  'linkedin_email',\n                  {\n                    trim: true,\n                    rules: [\n                      {\n                        required: true,\n                        validator: function (rule, value, callback) {\n                          let reg =\n                            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$/;\n                          if (\n                            !value ||\n                            !value.trim('') ||\n                            !reg.test(value)\n                          ) {\n                            callback($t('rightAccount'));\n                            return;\n                          }\n                          callback();\n                        },\n                      },\n                    ],\n                  },\n                ]",
                                            },
                                          ],
                                          staticClass: "process-input",
                                          attrs: {
                                            size: "large",
                                            autocomplate: "off",
                                            placeholder: _vm.$t("linkEmal"),
                                          },
                                          on: { change: _vm.changeHandler1 },
                                        },
                                        [
                                          _c("svg-icon", {
                                            attrs: {
                                              slot: "prefix",
                                              iconClass: "email",
                                            },
                                            slot: "prefix",
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-form-item",
                                    { class: [_vm.lang] },
                                    [
                                      _c(
                                        "a-input-password",
                                        {
                                          directives: [
                                            {
                                              name: "decorator",
                                              rawName: "v-decorator",
                                              value: [
                                                "linkedin_password",
                                                {
                                                  trim: true,
                                                  rules: [
                                                    {
                                                      required: true,
                                                      message:
                                                        _vm.$t("inputPwd"),
                                                    },
                                                  ],
                                                },
                                              ],
                                              expression:
                                                "[\n                    'linkedin_password',\n                    {\n                      trim: true,\n                      rules: [\n                        {\n                          required: true,\n                          message: $t('inputPwd'),\n                        },\n                      ],\n                    },\n                  ]",
                                            },
                                          ],
                                          staticClass: "process-input",
                                          attrs: {
                                            size: "large",
                                            type: "linkedin_password",
                                            oninput: "value=value.trim()",
                                            onchange: "value=value.trim()",
                                            placeholder: _vm.$t("linkPwd"),
                                          },
                                          on: { change: _vm.changePassword },
                                        },
                                        [
                                          _c("svg-icon", {
                                            attrs: {
                                              slot: "prefix",
                                              iconClass: "lock",
                                            },
                                            slot: "prefix",
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                        _c(
                          "div",
                          { staticClass: "cstep" },
                          [
                            _vm.processStep.step3 == 0
                              ? _c("div", { staticClass: "number" }, [
                                  _vm._v("3"),
                                ])
                              : _vm._e(),
                            _vm.processStep.step3 == 1
                              ? _c("svg-icon", {
                                  staticClass: "cicon",
                                  attrs: { iconClass: "wrong" },
                                })
                              : _vm._e(),
                            _vm.processStep.step3 == 2
                              ? _c("svg-icon", {
                                  staticClass: "cicon rotating",
                                  attrs: { iconClass: "load" },
                                })
                              : _vm._e(),
                            _vm.processStep.step3 == 3
                              ? _c("svg-icon", {
                                  staticClass: "cicon",
                                  attrs: { iconClass: "right" },
                                })
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass: "text",
                                class: {
                                  wrong: _vm.processStep.step3 == 1,
                                  right:
                                    _vm.processStep.step3 == 2 ||
                                    _vm.processStep.step3 == 3,
                                },
                              },
                              [
                                _c("span", { class: [_vm.lang] }, [
                                  _vm._v(_vm._s(_vm.$t("LinkedInAccountLink"))),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm.processStep.step3 == 1
                          ? _c(
                              "div",
                              {
                                staticClass: "splitbox getProxy",
                                staticStyle: {
                                  "border-left": "#fff solid 1px",
                                },
                              },
                              [
                                _c("div", { staticClass: "asset" }, [
                                  _c(
                                    "div",
                                    { staticClass: "faCodeBox" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "faCodeBox-title" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "faCodeBox-title-icon",
                                            },
                                            [_vm._v("🔒")]
                                          ),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.$t("FaCodeBoxTitle"))
                                            ),
                                          ]),
                                        ]
                                      ),
                                      _c("p", {
                                        staticClass: "faCodeBox-desc",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t("FaCodeBoxDesc")
                                          ),
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "faCodeBox-channels" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "faCodeBox-channel",
                                              class: {
                                                primary:
                                                  _vm.linkLoginInfo.action ===
                                                  "confirm_in_linkedin_app",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "faCodeBox-channel-head",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "faCodeBox-channel-icon",
                                                    },
                                                    [_vm._v("📱")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "faCodeBox-channel-text",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "faCodeBox-channel-title",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "FaCodeChannelAppTitle"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "faCodeBox-channel-desc",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "FaCodeChannelAppDesc"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "faCodeBox-channel-shot",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.viewLargerImg(
                                                        _vm.faChannelImgs.app
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.faChannelImgs
                                                        .app,
                                                      alt: _vm.$t(
                                                        "FaCodeChannelAppTitle"
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "faCodeBox-channel-view",
                                                  attrs: {
                                                    href: "javascript:void(0)",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.viewLargerImg(
                                                        _vm.faChannelImgs.app
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("FaCodeViewLarger")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "faCodeBox-channel",
                                              class: {
                                                primary:
                                                  _vm.linkLoginInfo.channel ===
                                                  "email",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "faCodeBox-channel-head",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "faCodeBox-channel-icon",
                                                    },
                                                    [_vm._v("✉️")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "faCodeBox-channel-text",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "faCodeBox-channel-title",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "FaCodeChannelEmailTitle"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "faCodeBox-channel-desc",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "FaCodeChannelEmailDesc"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "faCodeBox-channel-shot",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.viewLargerImg(
                                                        _vm.faChannelImgs.email
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.faChannelImgs
                                                        .email,
                                                      alt: _vm.$t(
                                                        "FaCodeChannelEmailTitle"
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "faCodeBox-channel-view",
                                                  attrs: {
                                                    href: "javascript:void(0)",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.viewLargerImg(
                                                        _vm.faChannelImgs.email
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("FaCodeViewLarger")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "faCodeBox-channel",
                                              class: {
                                                primary:
                                                  _vm.linkLoginInfo.channel ===
                                                  "authenticator_app",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "faCodeBox-channel-head",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "faCodeBox-channel-icon",
                                                    },
                                                    [_vm._v("🔐")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "faCodeBox-channel-text",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "faCodeBox-channel-title",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "FaCodeChannelAuthTitle"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "faCodeBox-channel-desc",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "FaCodeChannelAuthDesc"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "faCodeBox-channel-shot",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.viewLargerImg(
                                                        _vm.faChannelImgs.auth
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.faChannelImgs
                                                        .auth,
                                                      alt: _vm.$t(
                                                        "FaCodeChannelAuthTitle"
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "faCodeBox-channel-view",
                                                  attrs: {
                                                    href: "javascript:void(0)",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.viewLargerImg(
                                                        _vm.faChannelImgs.auth
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("FaCodeViewLarger")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "faCodeBox-channel",
                                              class: {
                                                primary:
                                                  _vm.linkLoginInfo.channel ===
                                                  "phone",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "faCodeBox-channel-head",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "faCodeBox-channel-icon",
                                                    },
                                                    [_vm._v("💬")]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "faCodeBox-channel-text",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "faCodeBox-channel-title",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "FaCodeChannelSmsTitle"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "faCodeBox-channel-desc",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "FaCodeChannelSmsDesc"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "faCodeBox-channel-shot",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.viewLargerImg(
                                                        _vm.faChannelImgs.sms
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: _vm.faChannelImgs
                                                        .sms,
                                                      alt: _vm.$t(
                                                        "FaCodeChannelSmsTitle"
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "faCodeBox-channel-view",
                                                  attrs: {
                                                    href: "javascript:void(0)",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.viewLargerImg(
                                                        _vm.faChannelImgs.sms
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("FaCodeViewLarger")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm.linkLoginInfo.action !==
                                      "confirm_in_linkedin_app"
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "faCodeBox-input-label",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("FaCodeInputLabel")
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "a-form-item",
                                              { class: [_vm.lang] },
                                              [
                                                _c("a-input", {
                                                  directives: [
                                                    {
                                                      name: "decorator",
                                                      rawName: "v-decorator",
                                                      value: [
                                                        "fa_code",
                                                        {
                                                          trim: true,
                                                          rules: [
                                                            {
                                                              required: true,
                                                              validator:
                                                                function (
                                                                  rule,
                                                                  value,
                                                                  callback
                                                                ) {
                                                                  if (
                                                                    !value ||
                                                                    !value.trim(
                                                                      ""
                                                                    )
                                                                  ) {
                                                                    callback(
                                                                      _vm.$t(
                                                                        "inputCode"
                                                                      )
                                                                    )
                                                                    return
                                                                  }
                                                                  callback()
                                                                },
                                                            },
                                                          ],
                                                        },
                                                      ],
                                                      expression:
                                                        "[\n                      'fa_code',\n                      {\n                        trim: true,\n                        rules: [\n                          {\n                            required: true,\n                            validator: function (rule, value, callback) {\n                              if (!value || !value.trim('')) {\n                                callback($t('inputCode'));\n                                return;\n                              }\n                              callback();\n                            },\n                          },\n                        ],\n                      },\n                    ]",
                                                    },
                                                  ],
                                                  staticClass: "process-input",
                                                  attrs: {
                                                    size: "large",
                                                    maxLength: _vm.maxLength,
                                                    autocomplete: "off",
                                                    placeholder:
                                                      _vm.$t("inputCode"),
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        : _vm._e(),
                                      _c(
                                        "a-modal",
                                        {
                                          attrs: {
                                            footer: null,
                                            centered: true,
                                            maskClosable: true,
                                            width:
                                              _vm.faPreviewImg ===
                                              _vm.faChannelImgs.sms
                                                ? "520px"
                                                : "720px",
                                            wrapClassName:
                                              "faCodeBox-preview-modal",
                                          },
                                          model: {
                                            value: _vm.faPreviewVisible,
                                            callback: function ($$v) {
                                              _vm.faPreviewVisible = $$v
                                            },
                                            expression: "faPreviewVisible",
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              width: "100%",
                                              "border-radius": "6px",
                                            },
                                            attrs: {
                                              src: _vm.faPreviewImg,
                                              alt: "",
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                ]),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _c("div"),
                    ]
                  : _vm._e(),
                _vm.$route.query.linkedin_id == "new" &&
                _vm.firstReg &&
                !_vm.isClickNext
                  ? [
                      _c(
                        "a-form-item",
                        {
                          class: [_vm.lang],
                          attrs: { label: _vm.$t("LinkedinAccountLabel") },
                        },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "a-input",
                                {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: [
                                        "linkedin_email",
                                        {
                                          trim: true,
                                          rules: [
                                            {
                                              required: true,
                                              validator: function (
                                                rule,
                                                value,
                                                callback
                                              ) {
                                                let reg =
                                                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
                                                if (
                                                  !value ||
                                                  !value.trim("") ||
                                                  !reg.test(value)
                                                ) {
                                                  callback(
                                                    _vm.$t("rightAccount")
                                                  )
                                                  return
                                                }
                                                callback()
                                              },
                                            },
                                          ],
                                        },
                                      ],
                                      expression:
                                        "[\n                'linkedin_email',\n                {\n                  trim: true,\n                  rules: [\n                    {\n                      required: true,\n                      validator: function (rule, value, callback) {\n                        let reg =\n                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$/;\n                        if (!value || !value.trim('') || !reg.test(value)) {\n                          callback($t('rightAccount'));\n                          return;\n                        }\n                        callback();\n                      },\n                    },\n                  ],\n                },\n              ]",
                                    },
                                  ],
                                  staticClass: "input",
                                  staticStyle: { height: "40px" },
                                  attrs: {
                                    size: "large",
                                    autocomplete: "off",
                                    disabled: _vm.inputDisabled,
                                    placeholder: _vm.$t(
                                      "LinkedinEmailPlaceholder"
                                    ),
                                  },
                                  on: { change: _vm.changeHandler1 },
                                },
                                [
                                  _c("svg-icon", {
                                    attrs: {
                                      slot: "prefix",
                                      iconClass: "email",
                                    },
                                    slot: "prefix",
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "a-form-item",
                        {
                          class: [_vm.lang],
                          attrs: { label: _vm.$t("PasswordLabel") },
                        },
                        [
                          _c(
                            "a-input-password",
                            {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: [
                                    "linkedin_password",
                                    {
                                      trim: true,
                                      rules: [
                                        {
                                          required: true,
                                          message: _vm.$t("inputPwd"),
                                        },
                                      ],
                                    },
                                  ],
                                  expression:
                                    "[\n              'linkedin_password',\n              {\n                trim: true,\n                rules: [\n                  {\n                    required: true,\n                    message: $t('inputPwd'),\n                  },\n                ],\n              },\n            ]",
                                },
                              ],
                              staticClass: "input",
                              staticStyle: { height: "40px" },
                              attrs: {
                                size: "large",
                                type: "linkedin_password",
                                oninput: "value=value.trim()",
                                onchange: "value=value.trim()",
                                autocomplete: "off",
                                disabled: _vm.inputDisabled,
                                placeholder: _vm.$t("PasswordPlaceholder"),
                              },
                              on: { change: _vm.changePassword },
                            },
                            [
                              _c("svg-icon", {
                                attrs: { slot: "prefix", iconClass: "lock" },
                                slot: "prefix",
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showTipsInfo,
                                  expression: "showTipsInfo",
                                },
                              ],
                              staticClass: "input-tip",
                            },
                            [
                              _c("span", { staticClass: "input-tip-icon" }, [
                                _vm._v("💡"),
                              ]),
                              _c("span", {
                                staticClass: "input-tip-text",
                                domProps: {
                                  innerHTML: _vm._s(_vm.$t("PasswordTipText")),
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        { class: [_vm.lang] },
                        [
                          _c("template", { slot: "label" }, [
                            _c("span", { staticClass: "tz-label" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("TimeZoneLabel"))),
                              ]),
                              _c("span", { staticClass: "tz-tag" }, [
                                _vm._v(" " + _vm._s(_vm.$t("TimeZoneTag"))),
                              ]),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "wrap-select" },
                            [
                              _c("svg-icon", {
                                staticClass: "prefix",
                                attrs: { iconClass: "timezone" },
                              }),
                              _c(
                                "a-select",
                                {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: [
                                        "timezone_config_id",
                                        {
                                          rules: [
                                            {
                                              required: true,
                                              message: _vm.$t("selectTimezone"),
                                            },
                                          ],
                                        },
                                      ],
                                      expression:
                                        "[\n              'timezone_config_id',\n              {\n                rules: [\n                  {\n                    required: true,\n                    message: $t('selectTimezone'),\n                  },\n                ],\n              },\n            ]",
                                    },
                                  ],
                                  staticClass: "input process-select",
                                  attrs: {
                                    size: "large",
                                    placeholder: _vm.$t("timeZone"),
                                  },
                                },
                                _vm._l(
                                  _vm.TimeZoneList,
                                  function (item, index) {
                                    return _c(
                                      "a-select-option",
                                      {
                                        key: index,
                                        class: [_vm.lang],
                                        attrs: { value: item.id },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(item.show_name) + " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showTipsInfo,
                                  expression: "showTipsInfo",
                                },
                              ],
                              staticClass: "input-tip",
                            },
                            [
                              _c("span", { staticClass: "input-tip-icon" }, [
                                _vm._v("💡"),
                              ]),
                              _c("span", {
                                staticClass: "input-tip-text",
                                domProps: {
                                  innerHTML: _vm._s(_vm.$t("TimeZoneTipText")),
                                },
                              }),
                            ]
                          ),
                        ],
                        2
                      ),
                      _c(
                        "a-form-item",
                        { class: [_vm.lang] },
                        [
                          _c("template", { slot: "label" }, [
                            _c("span", { staticClass: "tz-label" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("ProxyRegionLabel"))),
                              ]),
                              _c("span", { staticClass: "tz-tag" }, [
                                _vm._v(" " + _vm._s(_vm.$t("ProxyRegionTag"))),
                              ]),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "wrap-select" },
                            [
                              _c("svg-icon", {
                                staticClass: "prefix",
                                attrs: { iconClass: "global" },
                              }),
                              _c(
                                "a-select",
                                {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: [
                                        "country_config_id",
                                        {
                                          rules: [
                                            {
                                              required: true,
                                              message: _vm.$t("selectRegion"),
                                            },
                                          ],
                                        },
                                      ],
                                      expression:
                                        "[\n              'country_config_id',\n              {\n                rules: [\n                  {\n                    required: true,\n                    message: $t('selectRegion'),\n                  },\n                ],\n              },\n            ]",
                                    },
                                  ],
                                  staticClass: "input process-select",
                                  attrs: {
                                    size: "large",
                                    "filter-option": _vm.filterOption,
                                    showSearch: "",
                                    placeholder: _vm.$t(
                                      "ProxyRegionPlaceholder"
                                    ),
                                  },
                                },
                                _vm._l(
                                  _vm.locationList,
                                  function (item, index) {
                                    return _c(
                                      "a-select-option",
                                      {
                                        key: index,
                                        class: [_vm.lang],
                                        attrs: { value: item.id },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(item.show_name) + " "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showTipsInfo,
                                      expression: "showTipsInfo",
                                    },
                                  ],
                                  staticClass: "input-tip",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "input-tip-icon" },
                                    [_vm._v("💡")]
                                  ),
                                  _c("span", {
                                    staticClass: "input-tip-text",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("ProxyRegionTipText")
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                      _c(
                        "a-form-item",
                        { class: [_vm.lang] },
                        [
                          _c("template", { slot: "label" }, [
                            _c("span", { staticClass: "tz-label" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("WorkingHoursLabel"))),
                              ]),
                              _c("span", { staticClass: "tz-tag" }, [
                                _vm._v(" " + _vm._s(_vm.$t("WorkingHoursTag"))),
                              ]),
                            ]),
                          ]),
                          _c(
                            "div",
                            { staticClass: "wrap-select" },
                            [
                              _c("a-icon", {
                                staticClass: "prefix",
                                staticStyle: { color: "#0e756a" },
                                attrs: { type: "schedule" },
                              }),
                              _c(
                                "a-select",
                                {
                                  directives: [
                                    {
                                      name: "decorator",
                                      rawName: "v-decorator",
                                      value: [
                                        "working_time",
                                        {
                                          initialValue: 0,
                                          rules: [
                                            {
                                              required: true,
                                              message: _vm.$t("selectRegion"),
                                            },
                                          ],
                                        },
                                      ],
                                      expression:
                                        "[\n              'working_time',\n              {\n                initialValue: 0,\n                rules: [\n                  {\n                    required: true,\n                    message: $t('selectRegion'),\n                  },\n                ],\n              },\n            ]",
                                    },
                                  ],
                                  staticClass: "input process-select",
                                  attrs: {
                                    size: "large",
                                    placeholder: _vm.$t(
                                      "WorkingHoursPlaceholder"
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "a-select-option",
                                    { class: [_vm.lang], attrs: { value: 0 } },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("AlwaysOn")) + " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { class: [_vm.lang], attrs: { value: 1 } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("BusinessHoursMS")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "a-select-option",
                                    { class: [_vm.lang], attrs: { value: 2 } },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("BusinessHoursMF")) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showTipsInfo,
                                      expression: "showTipsInfo",
                                    },
                                  ],
                                  staticClass: "input-tip",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "input-tip-icon" },
                                    [_vm._v("💡")]
                                  ),
                                  _c("span", {
                                    staticClass: "input-tip-text",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("WorkingHoursTipText")
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                      _c("div", { staticClass: "faTips" }, [
                        _c("span", { staticClass: "faTips-icon" }, [
                          _vm._v("ℹ️"),
                        ]),
                        _c("span", {
                          staticClass: "faTips-text",
                          domProps: { innerHTML: _vm._s(_vm.$t("FaTipsText")) },
                        }),
                      ]),
                    ]
                  : _vm._e(),
                _vm.$route.query.linkedin_id == "new" &&
                _vm.firstReg &&
                !_vm.isClickNext
                  ? [
                      _c(
                        "a-form-item",
                        {
                          style: {
                            "text-align": _vm.lang == "AR" ? "right" : "left",
                          },
                        },
                        [
                          _c(
                            "a-button",
                            {
                              class: [_vm.lang],
                              attrs: {
                                size: "large",
                                type: "primary",
                                loading: _vm.loading,
                              },
                              on: { click: _vm.formNextHandler },
                            },
                            [_vm._v(_vm._s(_vm.$t("NextStep")))]
                          ),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm.detailObj.linkedin_id ||
                _vm.linkList.length > 0 ||
                _vm.loginLinkInfo.linkedin_id
                  ? _c(
                      "div",
                      [
                        _c("CampaginsControl", {
                          attrs: {
                            showTipsInfo: _vm.showTipsInfo,
                            dailyLimit: _vm.dailyLimit,
                            campaignsCount: _vm.campaignsCount,
                            allocationMode: _vm.allocationMode,
                            isLinked: false,
                            isLtd: _vm.is_ltd,
                          },
                          on: {
                            handleLimitChange: _vm.handleLimitChange,
                            allocationChange: _vm.allocationChange,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "a-form-item",
                  {
                    staticStyle: { "margin-top": "30px" },
                    style: {
                      "text-align": _vm.lang == "AR" ? "right" : "left",
                    },
                  },
                  [
                    _vm.detailObj.linkedin_id ||
                    _vm.new_linkedin_id ||
                    !_vm.firstReg
                      ? _c(
                          "a-button",
                          {
                            class: [_vm.lang],
                            attrs: {
                              size: "large",
                              type: "primary",
                              loading: _vm.nextBtnLoading,
                            },
                            on: { click: _vm.nextHandler },
                          },
                          [_vm._v(_vm._s(_vm.$t("NextStep")))]
                        )
                      : _vm._e(),
                    _vm.processing &&
                    (_vm.processStep.step1 == 1 ||
                      _vm.processStep.step2 == 1 ||
                      _vm.processStep.step3 == 1) &&
                    _vm.firstReg &&
                    !_vm.$route.query.edit
                      ? _c(
                          "a-button",
                          {
                            class: [_vm.lang],
                            attrs: { size: "large", type: "primary" },
                            on: { click: _vm.saveHandler },
                          },
                          [_vm._v(_vm._s(_vm.$t("ContinueConnect")))]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }